import { Flex, Heading, Tag } from '@chakra-ui/react';
import { AcrobatReaderIcon } from 'ui-components/dist/AcrobatReaderIcon';
import { GoogleSheetsLogoIcon } from 'ui-components/dist/GoogleSheetsLogoIcon';
import { DownloadCard } from '~/screens/MyAgency/components/ShareRosterModal';

export const Downloads: React.FC = () => (
  <>
    <Flex justifyContent="space-between" alignItems="center" marginTop={4}>
      <Heading
        as="h3"
        size="lg"
        fontSize="lg"
        fontWeight="medium"
        lineHeight="4.5"
      >
        Downloads
      </Heading>
      <Tag
        variant="solid"
        colorScheme="secondary"
        backgroundColor="secondary.50"
        color="secondary.900"
        paddingX={2}
        paddingY={1}
        fontWeight={500}
        lineHeight="12px"
        fontSize="2xs"
        borderRadius="100px"
      >
        Coming soon
      </Tag>
    </Flex>

    <Flex marginTop={2} gap={2}>
      <DownloadCard label="PDF" icon={AcrobatReaderIcon} />
      <DownloadCard label="Google Sheets" icon={GoogleSheetsLogoIcon} />
    </Flex>
  </>
);
